// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-page{
    margin-top:40px;
    float:left;
    margin-left: 5%;
    width:60%;
    position: absolute;
    max-width: 65%;
    z-index: -2;
    
}


.about-card{
    background-color: rgba(1, 1, 1, 0.15);
    margin-bottom: 5%;
    height: 250px;
    width : 1000px;
    max-height:100%;
    max-width: 100%;
    color: black;  
    border-radius: 10px;
}

.about-card:hover{
    background-color: rgba(102, 31, 53, 0.5);
}





.image-card{
    float:left;
    width: 40%;
    max-width: 150px;
    max-height: 250px;
    margin-left:40px;
    margin-bottom: 40px;
    margin-top:25px;
    
    
}
    
.image-card img{
    width:110%;
    height:200px;
    width:290px;
    max-height:100%;
    max-width: 100%;

}

.about-card-content{
    float:left;
    width:30%;
    margin-top:50px;
    margin-left:290px;
    max-width: 50%;
    max-height: 100px;
    text-align: start;
    position: absolute;
    ruby-position: right;
}


.page-right{
    margin-top:40px;
    width:30%;
    float:right;
    position: flex;
    max-width: 30%;

}


.contact{
    color:black;
    float: left;
    height:450px;
    width:90%;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    margin-left:-40px;
    position: flex;



}


.contact-content{

}


.contact:hover{
    background-color: rgba(255, 255, 255, 0.2);

}`, "",{"version":3,"sources":["webpack://./src/components/about/about.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,UAAU;IACV,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,WAAW;;AAEf;;;AAGA;IACI,qCAAqC;IACrC,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,eAAe;IACf,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;AAC5C;;;;;;AAMA;IACI,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;;;AAGnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;;AAEnB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;;AAGA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,cAAc;IACd,cAAc;;AAElB;;;AAGA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,SAAS;IACT,0CAA0C;IAC1C,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;;;;AAIlB;;;AAGA;;AAEA;;;AAGA;IACI,0CAA0C;;AAE9C","sourcesContent":[".main-page{\n    margin-top:40px;\n    float:left;\n    margin-left: 5%;\n    width:60%;\n    position: absolute;\n    max-width: 65%;\n    z-index: -2;\n    \n}\n\n\n.about-card{\n    background-color: rgba(1, 1, 1, 0.15);\n    margin-bottom: 5%;\n    height: 250px;\n    width : 1000px;\n    max-height:100%;\n    max-width: 100%;\n    color: black;  \n    border-radius: 10px;\n}\n\n.about-card:hover{\n    background-color: rgba(102, 31, 53, 0.5);\n}\n\n\n\n\n\n.image-card{\n    float:left;\n    width: 40%;\n    max-width: 150px;\n    max-height: 250px;\n    margin-left:40px;\n    margin-bottom: 40px;\n    margin-top:25px;\n    \n    \n}\n    \n.image-card img{\n    width:110%;\n    height:200px;\n    width:290px;\n    max-height:100%;\n    max-width: 100%;\n\n}\n\n.about-card-content{\n    float:left;\n    width:30%;\n    margin-top:50px;\n    margin-left:290px;\n    max-width: 50%;\n    max-height: 100px;\n    text-align: start;\n    position: absolute;\n    ruby-position: right;\n}\n\n\n.page-right{\n    margin-top:40px;\n    width:30%;\n    float:right;\n    position: flex;\n    max-width: 30%;\n\n}\n\n\n.contact{\n    color:black;\n    float: left;\n    height:450px;\n    width:90%;\n    background-color: rgba(255, 255, 255, 0.1);\n    border-radius: 10px;\n    margin-left:-40px;\n    position: flex;\n\n\n\n}\n\n\n.contact-content{\n\n}\n\n\n.contact:hover{\n    background-color: rgba(255, 255, 255, 0.2);\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
